function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    color: ",
        ";\n    font-size: ",
        ";\n    vertical-align: ",
        ";\n    user-select: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "styled-components";
import { Icon as MaterialIcon } from "@rmwc/icon";
import * as React from "react";
import { getButtonRoleProps } from "../shared/getButtonRoleProps";
import { iconColors } from "./iconColors";
// eslint-disable-next-line @typescript-eslint/no-var-requires
require("@rmwc/icon/icon.css");
export var KaggleIcon = styled(MaterialIcon)(_templateObject(), function(p) {
    return p.color || iconColors[p.theme.name][p.emphasis || "high"];
}, function(p) {
    return p.sizevalue;
}, function(p) {
    return p.verticalalign;
});
var sizeMap = {
    xxxsmall: "12px",
    xxsmall: "14px",
    xsmall: "18px",
    small: "20px",
    medium: "24px",
    large: "36px",
    xlarge: "48px",
    inline: "1.125em"
};
export var Icon = function(props) {
    var className = props.className, color = props.color, emphasis = props.emphasis, icon = props.icon, onClick = props.onClick, style = props.style, title = props.title;
    var size = props.size || "medium";
    var sizevalue = sizeMap[size] || size;
    var buttonProps = onClick ? getButtonRoleProps() : {};
    return /*#__PURE__*/ React.createElement(KaggleIcon, _extends({
        className: className,
        color: color,
        emphasis: emphasis,
        icon: icon,
        onClick: onClick,
        sizevalue: sizevalue,
        style: style,
        title: title,
        "aria-label": title
    }, buttonProps, {
        verticalalign: props.size === "inline" ? "-0.125em" : undefined
    }));
};
